

<template>
    <div class="location_shipment">
        <div class="form-group mt-2">
            <label class="form-label" for="shipping">
                {{__t("SHIPPING_TYPE")}}
            </label>

            <div class="" v-if="shippings.length > 0">
                <v-select v-model="location.shipping_id"
                          class="imc_reasons"
                          id="shipping"
                          label="title"

                          :reduce="shipping => shipping.id"
                          :options="this.shippings"
                          :filterable="false"
                >
                    <template slot="option" slot-scope="option">
                        <div class="d-center">
                            {{ option.title }}
                        </div>
                    </template>
                </v-select>
            </div>
        </div>

        <div class="form-group mt-2">
            <label class="form-label" for="shipping_delivery">
                {{__t("SHIPPING_TYPE_DELIVERY")}}
            </label>

            <div class="" v-if="shippings.length > 0">
                <v-select v-model="location.shipping_delivery_id"
                          class="imc_reasons"
                          id="shipping_delivery"
                          label="title"
                          :reduce="shipping => shipping.id"
                          :options="this.shippings"
                          :filterable="false"
                >
                    <template slot="option" slot-scope="option">
                        <div class="d-center">
                            {{ option.title }}
                        </div>
                    </template>
                </v-select>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import Fuse from 'fuse.js';
export default {
    name: "location_shipment",
    components : {
        vSelect
    },

    props : {
        location : {
            type : Object
        }
    },

    data() {
        return {
            shippings   : [],
        }
    },

    mounted() {
        this.load_shippings();
    },

    methods : {

        async load_shippings()
        {
            this.shippings = [];
            await api.get('/internal/v1/catalog/organizations/'+ parseInt(this.location.parent_id) +'/shipping').then(({data}) => {
                if (data.status === "operation_success") {
                    this.shippings = data.data;
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },
    }
}
</script>

<style scoped>

</style>
